import Form from '@rjsf/core';
import widgets from './Widgets';
import { useMemo } from 'react';

const DataForm = props => {
  return useMemo(
    () => (
      <Form {...props} widgets={widgets}>
        {props.children}
      </Form>
    ),
    [props.schema, props.formData, props.disabled]
  );
};

export default DataForm;
